import { Component, Input, OnInit, ChangeDetectorRef, ChangeDetectionStrategy } from "@angular/core";
import { ModuleManager } from "src/shared/models/module-manager";

@Component({
    selector: "cv-schedule-adherence-settings",
    templateUrl: "./schedule-adherence-settings.component.html",
    styleUrls: ["./schedule-adherence-settings.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ScheduleAdherenceSettingsComponent implements OnInit {

    @Input() moduleManager: ModuleManager;

    settings = {
        startDate: null,
    };

    constructor(private cdr: ChangeDetectorRef) { }

    ngOnInit(): void {
        this.moduleManager.addSetting({
            name: "ScheduleAdherenceStartDate",
            getValue: () => this.settings.startDate ? this.settings.startDate : new Date(),
            onSettingLoaded: (value) => {
                const date = typeof value === "string" ? new Date(value) : value;
                this.settings.startDate = date;
                this.cdr.markForCheck();
            },
            defaultValue: this.settings.startDate,
        });

        this.moduleManager.customSettingsAdded = true;
    }
}
